import { useLocation } from "react-router";

export const useQueryParams = (): URLSearchParams => new URLSearchParams(useLocation().search);
